import React, {createContext, ReactNode, useContext, useState} from "react";
import {Annotation, SubNetworkResult} from "../types/Types";
// Node menu state is handled globally via TheCellMapContext

interface SubNetworkContextType {
  subNetworkData: SubNetworkResult | null;
  setSubNetworkData: (data: SubNetworkResult | null) => void;
  maxLoadedPcc: number;
  setMaxLoadedPcc: (data: number) => void;
  displayedTerms: Annotation[];
  setDisplayedTerms: (terms: Annotation[]) => void;
  highlightedTerm: Annotation | undefined;
  setHighlightedTerm: (term: Annotation | undefined) => void;
  legendHoveredTerm: Annotation | undefined;
  setLegendHoveredTerm: (term: Annotation | undefined) => void;
  subNetworkCutoff: number;
  setSubNetworkCutoff: (cutoff: number) => void;
}

const SubNetworkContext = createContext<SubNetworkContextType | undefined>(undefined);

interface SubNetworkProviderProps {
  children: ReactNode;
}

export const SubNetworkProvider: React.FC<SubNetworkProviderProps> = ({children}) => {
  const [subNetworkData, setSubNetworkData] = useState<SubNetworkResult | null>(null);
  const [maxLoadedPcc, setMaxLoadedPcc] = useState<number>(1);
  const [displayedTerms, setDisplayedTerms] = useState<Annotation[]>([]);
  const [highlightedTerm, setHighlightedTerm] = useState<Annotation | undefined>(undefined);
  const [legendHoveredTerm, setLegendHoveredTerm] = useState<Annotation | undefined>(undefined);
  const [subNetworkCutoff, setSubNetworkCutoff] = useState<number>(0.5);

  return (
    <SubNetworkContext.Provider
      value={{
        subNetworkData,
        setSubNetworkData,
        maxLoadedPcc,
        setMaxLoadedPcc,
        displayedTerms,
        setDisplayedTerms,
        highlightedTerm,
        setHighlightedTerm,
        legendHoveredTerm,
        setLegendHoveredTerm,
        subNetworkCutoff,
        setSubNetworkCutoff,
      }}
    >
      {children}
    </SubNetworkContext.Provider>
  );
};

export const useSubNetworkContext = () => {
  const context = useContext(SubNetworkContext);
  if (!context) {
    throw new Error('useSubNetworkContext must be used within an SubNetworkProvider');
  }
  return context;
};
